import odontogramaServices from "@/api/odontograma/odontogramaServices";

export default {
  loadOndontogramas({ commit }) {
    return new Promise((resolve, reject) =>
      odontogramaServices
        .loadOndontogramas()
        .then((result) => {
          resolve(result.data.content);
        })
        .catch((err) => reject(err)),
    );
  },
  generate({ commit }, data) {
    return odontogramaServices
      .generate(data)
      .then((result) => result)
      .catch((error) => error);
  },
  editTooth({ commit }, data) {
    return odontogramaServices
      .editTooth(data)
      .then((result) => result)
      .catch((error) => error);
  },
  getById(id) {
    return odontogramaServices
      .getById(id)
      .then((result) => result.data)
      .catch((error) => error);
  },
  getPatientById(id) {
    return new Promise((resolve, reject) =>
      odontogramaServices
        .getPatientById(id)
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => reject(err)),
    );
  },
  getStatus({ commit }) {
    return odontogramaServices
      .getStatus()
      .then((result) => result)
      .catch((error) => error);
  },
};
